import { AnimatedYeatiText } from "@/shared/components/animatedYeatiText";
import { useOrganizationInfo } from "@/shared/hooks/useOrganizationInfo";

type OrganizationLogoProps = {
  className?: string
  alt?: string
  fallbackSrc?: string
  hideFallback?: boolean
  logoUrl?: string | null
};

export const OrganizationLogo = ({
  className = "max-h-28 w-auto",
  alt = "Logo de l'organisation",
  fallbackSrc = "/vite.svg",
  hideFallback = false,
  logoUrl,
}: OrganizationLogoProps) => {
  const { logo, hasLogo } = useOrganizationInfo();

  // Use provided logoUrl prop if available, otherwise fall back to hook data
  const logoSrc = (logoUrl ?? (logo?.url || logo?.medium_url)) || fallbackSrc;
  const shouldShowLogo = logoUrl
    ? logoUrl !== fallbackSrc
    : hasLogo && logoSrc !== fallbackSrc;

  if (shouldShowLogo && logoSrc) {
    return <img src={logoSrc} className={className} alt={alt} />;
  }

  if (hideFallback) {
    return null;
  }

  return <AnimatedYeatiText replaceLogo />;
};
